const CACHE_VERSION = 1;
const DEFAULT_TTL_MS = 5 * 60 * 1000;

const serializeValue = (value) => {
  if (value == null) return value;
  if (typeof value.toDate === 'function') {
    return value.toDate().toISOString();
  }
  if (typeof value === 'object' && typeof value.seconds === 'number') {
    return new Date(value.seconds * 1000).toISOString();
  }
  if (Array.isArray(value)) {
    return value.map(serializeValue);
  }
  if (typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, nested]) => [key, serializeValue(nested)])
    );
  }
  return value;
};

export const readSettingsLocalCache = (key, ttlMs = DEFAULT_TTL_MS) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (parsed?.v !== CACHE_VERSION || !parsed?.t || !parsed?.data) return null;
    if (Date.now() - parsed.t > ttlMs) return null;
    return parsed.data;
  } catch {
    return null;
  }
};

export const writeSettingsLocalCache = (key, data) => {
  try {
    localStorage.setItem(
      key,
      JSON.stringify({
        v: CACHE_VERSION,
        t: Date.now(),
        data: serializeValue(data),
      })
    );
  } catch {
    // Ignore quota or privacy mode errors.
  }
};

export const clearSettingsLocalCache = (key) => {
  try {
    localStorage.removeItem(key);
  } catch {
    // Ignore.
  }
};

export const SITE_SETTINGS_CACHE_KEY = 'tda_site_settings_v1';
export const CONFERENCE_SETTINGS_CACHE_KEY = 'tda_conference_settings_v1';
